import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        penalties: {data: [], current_page: 1, total: 0, per_page: 10},
        penalty_payments: {data: [], current_page: 1, total: 0, per_page: 10},
        penalty: {},
        errors: {
            data: {
                errors: {
                    name: [],
                }
            }
        },
        has_errors: false,
        loading: false,
    },
    getters: {
        dialogVisible: state => state.dialogVisible,
        penalties: state => state.penalties,
        penalty: state => state.penalty,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        loading: state => state.loading,
        penalty_payments: state => state.penalty_payments
    },
    mutations: {
        setPenaltyPayments(state, data) {
            state.penalty_payments = data
        },
        setLoading(state, status) {
            state.loading = status
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setPenalties(state, data) {
            state.penalties = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            name: [],
                        }
                    }
                };
            }
        }
    },
    actions: {
        async getPenalties({commit}, filters) {
            try {
                commit('activateLoading', 'penalty/list', {root: true});
                const response = await api.getPenalties(filters);
                commit('setPenalties', response.data);
                commit('deactivateLoading', 'penalty/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async getPenaltyPayments({commit}, filters) {
            try {
                commit('activateLoading', 'penalty/list', {root: true});
                const response = await api.getPenaltyPayments(filters);
                commit('setPenaltyPayments', response.data);
                commit('deactivateLoading', 'penalty/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async createPenalty({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.createPenalty(data);
                dispatch('getPenalties', {
                    paginate: true
                })
                ElMessage.success('Penalty created successfully!');
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error creating Penalty!');
            }
        },
        async editPenalty({dispatch, commit}, data) {
            try {
                await api.editPenalty(data);
                dispatch('getPenalties', {
                    paginate: true
                });
                commit('hasErrors', false)
                ElMessage.success('Penalty updated successfully!');
            } catch (e) {
                commit('setErrors', e.response)
                commit('hasErrors', true)
                ElMessage.error('Error updating Penalty');
            }
        },

        async deletePenalty({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                await api.deletePenalty(data);
                dispatch('getPenalties', {
                    paginate: true
                });
                ElMessage.success('Penalty removed successfully!');
            } catch (e) {
                ElMessage.error('Error removing Penalty');
            }
        },


    }
}
